export const dashboardPaths = {
  trafficAnalysis: "/optimization/funnel",
  trafficDetails: "/optimization/traffic-details",
  trafficDetailsCountries: "/traffic-details/countries",
  competitorsMonitoring: "/competitors-monitoring",
  competitorFocus: "/competitor-focus",
  brandWayback: "/brand-wayback",
  competitorDomain: "/competitor/:domain",
  businessOverview: "/optimization/overview",
  brandOverview: "/brand-overview",
  textAds: "/text-ads",
  productListingAds: "/product-listing-ads",
  conversionsAnalysis: "/optimization/conversions-analysis",
  campaignExplorer: "/optimization/campaigns",
  visibility: "/visibility/overview",
  competitionEvolution: "/visibility/competition-evolution",
  competitiveSearchTermAnalysis: "/visibility/st-analysis",
  competitiveAds: "/visibility/ads",
  nonBrandedSearchTerms: "/non-branded/search-terms",
  nonBrandedCompetitors: "/non-branded/competitors",
  nonBrandOverview: "/non-branded",
  brandPulse: "/brand-pulse",
  brandPulseCompetitorsSelection: "/brand-pulse/competitors-selection",
  brandPulseCompetitors: "/brand-pulse/competitors",
  clusterManager: "/optimization/cluster-manager",
  nonBrandedConquestMode: "/non-branded/conquest-mode",
}; 